// v2/components/V2Shell.js
// Tum /v2 sayfalarinin ortak sarmalayicisi:
//  1) oturum kontrolu (token yoksa /login'e yonlendirir)
//  2) arka planda /api/v2/auth/session/ ile oturumu + borc engelini sorar;
//     engelliyse token sunucuda iptal edilir, giris ekraninda engel penceresi gosterilir
//  3) sepet context'ini SADECE v2 route'lari icin acar (eski sayfalar etkilenmez)

import React, { useEffect, useRef } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { CartProvider } from '../hooks/CartContext';
import ScrollToTop from './ScrollToTop';
import { oturumBilgisi, oturumuSonlandir, LOGIN_YOLU } from '../utils/authStore';
import { apiGet } from '../utils/api';

export default function V2Shell() {
  const konum = useLocation();
  const { girisli } = oturumBilgisi();
  const kontrolEdildi = useRef(false);

  useEffect(() => {
    if (!girisli || kontrolEdildi.current) return;
    kontrolEdildi.current = true;
    let iptal = false;
    (async () => {
      try {
        const veri = await apiGet('/v2/auth/session/', { oturumsuz: true });
        if (!iptal && (!veri || !veri.success)) oturumuSonlandir();
      } catch (e) {
        if (iptal) return;
        const d = (e && e.data) || {};
        if (d.code === 'DEBT_BLOCKED') {
          // giris ekrani engel penceresini gostersin
          try { window.sessionStorage.setItem('v2_borc_engel', JSON.stringify(d.restriction || {})); } catch (x) { /* yok say */ }
          oturumuSonlandir();
        } else if (e && e.status === 401) {
          oturumuSonlandir();
        }
        // ag hatasi: gecici; oturumu dusurme
      }
    })();
    return () => {
      iptal = true;
    };
  }, [girisli]);

  if (!girisli) {
    return <Navigate to={LOGIN_YOLU} replace state={{ from: konum.pathname }} />;
  }

  return (
    <CartProvider>
      <ScrollToTop />
      <Outlet />
    </CartProvider>
  );
}
